module.exports = __webpack_public_path__ + "media/images/fighting-tea-c89f999aa1d89fec2e864451ac211641.jpg";